import Slider from 'react-slick';
import { RESTAURANT } from '../../../utils/constants';

const gallery = require.context('../../../assets/imgs/restaurant', true);
const galleryList = gallery?.keys().map((image: any) => gallery(image));

const Restaurant = () => {
  const slickSettingsImgs = {
    focusOnSelect: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 400,
        settings: {
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div id={RESTAURANT} className='restaurant'>
      <div className='restaurant_container container'>
        <h2 data-aos='fade-up' className='text_center'>
          DINE AT TIFFANY RESTAURANT
        </h2>
        <p data-aos='fade-up' data-aos-delay='50'>
          Enjoy traditional food and local wines.
        </p>
        <p data-aos='fade-up' data-aos-delay='100'>
          The restaurant serves local and international cuisine from our a la
          carte menu. Choose from a variety of local and international wines.
        </p>
        <p data-aos='fade-up' data-aos-delay='150'>
          Enjoy the food at Tiffany Restaurant.
        </p>
        <p data-aos='fade-up' data-aos-delay='200'>
          Come and enjoy the taste of local cuisine at restaurant “Tiffany”.
        </p>
        <p data-aos='fade-up' data-aos-delay='250'>
          Our a la carte menu offers traditional Dalmatian food and
          international classics as well as an extensive wine list.
        </p>
        <p data-aos='fade-up' data-aos-delay='300'>
          The restaurant's location next to the Silver Gate of the Diocletians
          palace adds to the special dining experience.
        </p>
        <p data-aos='fade-up' data-aos-delay='350'>
          The restaurant serves breakfast and dinner.
        </p>
        <p data-aos='fade-up' data-aos-delay='400'>
          Visit us and enjoy.
        </p>
        <div data-aos='fade-up' data-aos-delay='450'>
          <Slider {...slickSettingsImgs}>
            {galleryList.map((x) => (
              <div className='restaurant_container_slider_container'>
                <div className='restaurant_container_slider_container_img'>
                  <img src={x} alt={x.indexOf(galleryList)} />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Restaurant;
